
type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
const columnList: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 164,
    },
    {
        prop: "specification",
        label: "规格",
        width: 75,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 75,
    },
    {
        prop: "mountings_type_pname",
        label: "大类",
        width: 75,
    },
    {
        prop: "mountings_type_name",
        label: "小类",
        width: 75,
    },
    {
        prop: "mountings_brand_name",
        label: "配件品牌",
        width: 75,
    },
    {
        prop: "unit_price",
        label: "库存单价",
        width: 75,
    },
    {
        prop: "cost_price",
        label: "成本价",
        width: 75,
    },
    {
        prop: "selling_price",
        label: "销售价",
        width: 75,
    },
    {
        prop: "build_bonus_price",
        label: "施工提成",
        width: 75,
    },
    {
        prop: "sell_bonus_price",
        label: "销售提成",
        width: 75,
    },
    {
        prop: "reappearance_type_name",
        label: "返现方案",
        width: 75,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList, permissionList,
} from "@/api/http";
import { validateInput, validateClass } from "@/assets/js/formRules";
import { partsFormType } from "@/assets/types/common";
export default defineComponent({
    name: "PartsManagement",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["配件管理"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<parts>),
            total = ref(0),
            roleList = ref({} as any),
            loading = ref(true),
            // 筛选
            selectGroup = reactive({
                status: "",
                set:"",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pid: "",
                mountings_type_id: "",
                mountings_brand_id: "",
                search:''
            }),
            select = reactive({
                mountings_ptype_data: [],
                mountings_type_data: [],
                reappearance_type_data: [],
                mountings_brand_data: [],
                mountings_unit_data: [],
            }),
            remote_loading = ref(false),
            dialogFormVisible = ref(false),
            dialogTitle = ref("新增配件"),
            formRef = ref(null),
            form = ref({
                name: "",
                mountings_type_pid: null,
                mountings_type_id: null,
                cost_price: null,
                selling_price: null,
                price_lock: 1,
                mountings_brand_id: null,
                specification: "",
                encoding: null,
                unit_id: null,
                build_bonus_type: 1,
                build_bonus_price: null,
                sell_bonus_type: 1,
                sell_bonus_price: null,
                return_cash_plan: null,
                describe: "",
                is_warning:1,
            } as partsFormType),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
				cost_price: [{required: true,message: '必填',trigger: "change"}],
				mountings_type_pid: [{required: true,message: '必填',trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let pridata = {
                    type:1,
                    role_name:'management',
                };
                permissionList(pridata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
				let data = {
				    ...selectGroup,
					pagesize:pageSize.value,
					page:currentPage.value,
                    isShow:1
				};
                getManagementTable(data).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res.content.count;
                });
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(select, res?.content || {});
                    remote_loading.value = false;
                });
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({ search: e });
            },
            formSelectChange = (e: number) => {
                getSelectData({ type_pid: e });
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            selectChange = (e:any,type:string)=> {
                getTableData();
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_id) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            columnChange = (
                item: partsFormType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑配件";
                    isEdit.value = true;
                    dialogFormVisible.value = true;
                    let data: any = { ...form.value, id: 0 };
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({ type_pid: form.value.mountings_type_pid });
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            submitForm = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        if (isEdit.value) {
                            getManagementTableEdit(form.value).then((res) =>
                                getTableData()
                            );
                        } else {
                            getManagementTableAdd(form.value).then((res) =>
                                getTableData()
                            );
                        }
                    }
                    dialogFormVisible.value = !valid;
                });
            };
        onMounted(() => {
            getTableData();
            getSelectData({});
        });
        watch(dialogFormVisible, (newValue, oldValue) => {
            if (oldValue) {
                form.value = {
                    name: "",
                    mountings_type_pid: null,
                    mountings_type_id: null,
                    cost_price: null,
                    selling_price: null,
                    price_lock: 1,
                    mountings_brand_id: null,
                    specification: "",
                    unit_id: null,
                    encoding: null,
                    build_bonus_type: 1,
                    build_bonus_price: null,
                    sell_bonus_type: 1,
                    sell_bonus_price: null,
                    return_cash_plan: null,
                    describe: "",
                    is_warning:1
                } as partsFormType;
                isEdit.value = false;
                dialogTitle.value = "新增配件";
                (formRef.value as any).resetFields();
            }
        });

        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            select,
            remote_loading,
            dialogFormVisible,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            submitForm,
            selectChange,
            roleList
        };
    },
});
